module.exports = __webpack_public_path__ + "img/03.56b86347.png";